import { ColumnDef } from "@tanstack/react-table";
import AdvanceTable from "components/base/AdvanceTable";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import Avatar from "components/base/Avatar";
import Badge from "components/base/Badge";
import RevealDropdown, {
  RevealDropdownTrigger,
} from "components/base/RevealDropdown";
import ActionDropdownItems from "components/common/ActionDropdownItems";
import {
  DealDetailsTableData,
  dealsdetailstableData,
} from "data/crm/dealdetailstableData";
import axiosInstance from "helpers/api";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

interface relatedParties {
  lead_id: any;
  // dealOwner: {
  //   // avatar?: string;
  //   name: string;
  //   role: string;
  //   role_id: string;
  //   // profileLink: string;
  // };
  role: string;
  name: string;
  lead: {
    lead_first_name: string;
    lead_last_name: string;
    id: string;
  };
}

export const columns: ColumnDef<relatedParties>[] = [
  // {
  //   id: "deal",
  //   accessorFn: ({ role }) => role,
  //   header: "Deal Owner",
  //   cell: ({ row: { original } }) => {
  //     return (
  //       <Link to={"#"} className="d-flex align-items-center text-body">
  //         {/* <Avatar src={avatar} size="m" /> */}
  //         <p className="mb-0 text-body-emphasis fw-bold">
  //           {original.lead.lead_first_name + " " + original.lead.lead_last_name}
  //         </p>
  //       </Link>
  //     );
  //   },
  //   meta: {
  //     headerProps: {
  //       style: { minWidth: 50 },
  //       className: "pe-5 text-nowrap",
  //     },
  //     cellProps: { className: "white-space-nowrap pe-5 py-0" },
  //   },
  // },

  {
    accessorKey: "deal",
    header: "Name",
    cell: ({ row: { original } }) => {
      const { lead } = original;
      return (
        <div className="d-flex align-items-center">
          <Link to={`/leads/${original?.lead_id}`} className="fs-8 fw-bold ps-2">
            {lead?.lead_first_name + " " + lead?.lead_last_name}
          </Link>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: "25%" }, className: "ps-0" },
      cellProps: { className: "white-space-nowrap ps-0" },
    },
  },
  {
    accessorKey: "role",
    header: "Role",
    cell: ({ row: { original } }) => {
      return (
        <div className="d-flex flex-wrap align-items-center gap-2">
          <Badge variant="phoenix" bg="success">
            {original?.role}
          </Badge>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: "25%" }, className: "ps-0" },
      cellProps: { className: "white-space-nowrap ps-0" },
    },
  },

  {
    id: "action",
    cell: ({ row: { original } }) => {
      return (
        <RevealDropdownTrigger>
          <RevealDropdown>
            <Dropdown.Item
              as={Link}
              to={`/leads/${original?.lead_id}`}
              eventKey="1"
            >
              View
            </Dropdown.Item>
          </RevealDropdown>
        </RevealDropdownTrigger>
      );
    },
    meta: {
      headerProps: {
        className: "text-end ps-4",
      },
      cellProps: { className: "text-end ps-4 py-0" },
    },
  },
];

const DealDetailsTable = ({ relatedParties }: any) => {
  // const fetchRelatedParty = async () => {
  //   const response = await axiosInstance.get(
  //     "/deals/01jn0twm37a14dh7bykv3de1f2/related-parties"
  //   );
  //   console.log(relatedPartiesData);

  //   setRelatedPartiesData(response.data.data);
  // };

  // const [relatedPartiesData, setRelatedPartiesData] = useState([]);

  const table = useAdvanceTable({
    data: relatedParties,
    columns,
    pageSize: 5,
    pagination: true,
    sortable: true,
    selection: false,
  });

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="border-y border-translucent">
          <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
          <AdvanceTableFooter pagination />
        </div>
      </AdvanceTableProvider>
    </div>
  );
};

export default DealDetailsTable;
